import dayPlannerImage from "../assets/day-planner-card.webp";

export default function DayPlannerCard() {
	return (
		<div className="w-full h-full flex items-center justify-center">
			<img src={dayPlannerImage} alt="Day planner card" className="w-full h-auto rounded-lg" />
		</div>
	);
}
